
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import { mockProducts } from '../../../mocks/products';
import DealHero from './components/DealHero';
import DealFeatures from './components/DealFeatures';
import DealDescription from './components/DealDescription';
import RelatedDeals from './components/RelatedDeals';

export default function DealDetailPage() {
  const { id } = useParams<{ id: string }>();
  const product = mockProducts.find((p) => p.id === id);

  if (!product) {
    return (
      <div className="min-h-screen bg-carbon-950 flex flex-col">
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <div className="w-20 h-20 bg-white/5 flex items-center justify-center mx-auto mb-6">
              <i className="ri-error-warning-line text-3xl text-white/20"></i>
            </div>
            <h2 className="text-2xl font-bold text-white mb-3">Deal Not Found</h2>
            <p className="text-white/40 text-sm mb-8">
              The deal you are looking for does not exist or has been removed.
            </p>
            <Link
              to="/websites"
              className="inline-block px-8 py-3 bg-neon text-black text-sm font-bold rounded-none hover:bg-neon/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>Back to Deals
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const interestLabel =
    product.clicks > 3500
      ? { text: 'Most Popular', icon: 'ri-fire-fill', cls: 'bg-neon/10 text-neon' }
      : product.clicks > 2500
      ? { text: 'Trending', icon: 'ri-thumb-up-fill', cls: 'bg-amber-500/10 text-amber-400' }
      : { text: 'Recommended', icon: 'ri-star-line', cls: 'bg-white/5 text-white/50' };

  const related = mockProducts
    .filter((p) => p.category === product.category && p.id !== product.id)
    .slice(0, 3);

  return (
    <div className="min-h-screen bg-carbon-950">
      <Navbar />
      <DealHero product={product} interestLabel={interestLabel} />
      <DealFeatures features={product.features} />
      <DealDescription product={product} />
      <RelatedDeals deals={related} />
      <Footer />
    </div>
  );
}
